import axios from "axios";

const instance = axios.create({
	headers: {
		"X-Frontend-Secret": process.env.REACT_APP_API_SECRET,
	}
});

export default instance;
